export default __webpack_public_path__ + "static/media/male_short_thin.250d82e0.png";